import { apiRequest } from '@/utils/request'

// 添加投诉建议
export function addSuggestion(data) {
  return apiRequest({
    url: '/Suggestion/Add',
    method: 'post',
    data: data
  })
}

// 获取文书格式分类分页列表
export function getDocumentCategoryList(queryParams) {
  return apiRequest({
    url: '/Document/GetCategoryListData',
    method: 'get',
    params: queryParams
  })
}

// 获取文书格式列表
export function getDocumentList(queryParams) {
  return apiRequest({
    url: '/Document/GetList',
    method: 'get',
    params: queryParams
  })
}

// 获取常见问题分类分页列表
export function getIssueCategoryList(queryParams) {
  return apiRequest({
    url: '/Issue/GetCategoryListData',
    method: 'get',
    params: queryParams
  })
}

// 获取常见问题列表
export function getIssueList(queryParams) {
  return apiRequest({
    url: '/Issue/GetList',
    method: 'get',
    params: queryParams
  })
}

// 添加在线咨询
export function addConsultation(data) {
  return apiRequest({
    url: '/Consultation/Add',
    method: 'post',
    data: data
  })
}

// 获取在线咨询列表
export function getConsultationList(queryParams) {
  return apiRequest({
    url: '/Consultation/GetList',
    method: 'get',
    params: queryParams
  })
}

// 根据房屋坐落获取个人名下房屋信息列表
export function getPersonalHouseInfoListByAddress(queryParams) {
  return apiRequest({
    url: 'GFT/GetPersonalHouseInfoListByAddress',
    method: 'get',
    params: queryParams
  })
}

// 获取在线扫码所得信息
export function getOnlineScanCodeInfo(queryParams) {
  return apiRequest({
    url: '/OnlineScanCode/GetData',
    method: 'get',
    params: queryParams
  })
}

// 获取不动产档案不动产单元信息（高安）
export function GetBdcDaBdcdy(queryParams) {
  return apiRequest({
    url: 'DciBdc/GetBdcDaBdcdy',
    method: 'get',
    params: queryParams
  })
}
